export const du = "https://gelo-website-default-rtdb.firebaseio.com";